import BaseListStore from './BaseListStore';

class PawnsStoreClass extends BaseListStore {}
const PawnsStore = new PawnsStoreClass('pawns', 'me', {
    status: 'ACTIVE',
    text: '',
});
export default PawnsStore;
